export default __webpack_public_path__ + "static/abaca-resort-mactan-507af9e0b7f4053c0d78fb09c7674c2a.svg";